var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('label', {
    staticClass: "switch-container input-margin"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "id": _vm.id
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": _vm.updateValue
    }
  }), _c('span', {
    staticClass: "container-align"
  }, [_c('span', {
    staticClass: "switch",
    class: _vm.switchClass
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.label))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };